import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { Subscription } from 'rxjs/internal/Subscription';
import { mergeMap, shareReplay } from 'rxjs/operators';
import { UserService } from '../../../shared/services/user/user.service';
import { NotificationService } from '../../v2-node-api/services/notification.service';
import { Notification } from '../interfaces/notification-base.interface';
import { NotificationWithSoundAlerts } from '../interfaces/notify-with-sound.interface';
import { DocumentRequestSocketService } from './document-request-socket.service';
import { NotificationsConfigurationService } from './notifications-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentRequestNotificationsService extends NotificationWithSoundAlerts {
  protected onAnswerSubscription: Subscription = null;

  constructor(
    protected notificationsSocketService: DocumentRequestSocketService,
    protected userService: UserService,
    protected notificationService: NotificationService,
  ) {
    super('documentRequest', notificationsSocketService);
    this.extraListen();
    this.soundPath = '../assets/audio/alert2.mp3';
    this.join();
    this.configuration = new NotificationsConfigurationService();
    this.configuration.getSound$().subscribe(on => {
      if (on) {
        this.subscribeToSoundAlert();
      } else {
        this.unsubscribeToSoundAlert();
      }
    });
  }

  join(): void {
    this.notificationSocket.on('connect', () => {
      this.userService.connectedUser().then(user => {
        this.notificationSocket.emit('join', user);
      });
    });
  }

  initNotifications(): Observable<Notification> {
    return this.notificationService.getByDomain(this.domain).pipe(
      shareReplay(),
      mergeMap((notifications) => {
        return of(...notifications);
      })
    );
  }

  public extraListen() {
    const eventType = 'Received';
    const eventName = this.domain + 'Validated' + eventType;
    this.onAnswerSubscription = this.notificationSocket
      .fromEvent(eventName)
      .subscribe((notification: Notification) => {
        this.notifications$.next(notification);
      });
  }
}
